import React from 'react';

import { STATIC_ASSET_URL } from '../../../../utils/content-templates';
import Icon, { COLORS, ICONS } from '../../../general-components/icon';

interface Props {
	stylepack: string,
	currItemUniqueId: string
	addNew: () => void
}

const gradientSvg = <svg xmlns="http://www.w3.org/2000/svg" width="425" height="710" viewBox="0 0 425 710" fill="none">
  <g opacity="0.2" filter="url(#filter0_f_54015_213710)">
    <circle cx="123" cy="123" r="123" transform="matrix(-1 0 0 1 323 203.552)" fill="#FF6AE6"/>
  </g>
  <defs>
    <filter id="filter0_f_54015_213710" x="-183" y="-56.4482" width="766" height="766" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="130" result="effect1_foregroundBlur_54015_213710"/>
    </filter>
  </defs>
</svg>

export default function AddThemeSplash(props: Props) {
	return (
		<div className='add-theme-splash'>
			<img src={`${STATIC_ASSET_URL}/tellys/magic.png`}/>
			<h5 className='bl-font-header lemonade-text'>Welcome to Your Themes!</h5>
			<div className='bl-font-p2'>You can import themes from your Brandlive Platform’s</div>
			<div className='bl-font-p2'>channel or create a new one</div>
			<div className='gradient-wrapper'>{gradientSvg}</div>
			<button onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				props.addNew();
			}} className='button-pillbox sherbert' style={{marginBottom: '64px'}}>
				<Icon name={ICONS.ADD} size={16} color={COLORS.BLACK}/>
				<span>Add</span>
			</button>
		</div>
	);
}
